angular.module('property.import', ['property'])
    .service('PropertyImportService', function (modals) {
        this.import = () => modals.open('app/property/import-modal.html', 'PropertyImportController', {}, {size: 'lg'}, "$ctrl");
    })
    .controller('PropertyImportController', function ($cookies, $scope, $rootScope, $http, $uibModalInstance, toastr, FileUploader) {
        this.entityPathCsv = "/crm/api/property-csv"
        this.types = ["CSV-SIMPLE-INITIAL", "CSV-SIMPLE"];

        this.import = {
            type: "CSV-SIMPLE",
            charset: "UTF-8",
            createRelatives: false,
            project: null,
            statusUpdate: false,
            pricingUpdate: false,
            notesUpdate: false
        };
        this.data = [];

        function createUploader(entityPathCsv, importForm, responseDataFn) {
            let uploader = new FileUploader({
                url: entityPathCsv + '/read-data',
                autoUpload: true,
                headers: {
                    "X-Requested-With": 'XMLHttpRequest',
                    "X-CSRF-TOKEN": $cookies.get("CSRF-TOKEN")
                }
            });
            uploader.onSuccessItem = (fileItem, response, status, headers) => {
                toastr.success("Wczytano dane z pliku");
                responseDataFn(response);
                angular.element("input[type='file']").val(null);
            };
            uploader.onErrorItem = (fileItem, rejection, status, headers) => {
                if (angular.isArray(rejection.messages)) {
                    angular.forEach(rejection.messages, (message, key) => toastr.error(message));
                }
            };
            uploader.onBeforeUploadItem = item => item.formData.push(importForm);
            return uploader;
        }

        this.uploader = createUploader(this.entityPathCsv, this.import, response => this.data = response);

        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.save = () => {
            if (this.isSaving)
                return;
            this.isSaving = true;

            let onSaveSuccess = result => {
                toastr.success("Zapisano");
                $rootScope.$broadcast('property.updated');
                $uibModalInstance.close(result);
                this.isSaving = false;
            };

            let onSaveError = () => {
                this.isSaving = false;
            };
            let content = {
                items: this.data,
                createRelatives: this.import.createRelatives,
                project: this.import.project,
                statusUpdate: this.import.statusUpdate,
                pricingUpdate: this.import.pricingUpdate,
                notesUpdate: this.import.notesUpdate,
            };
            $http.post(this.entityPathCsv + '/save-data', content).then(onSaveSuccess, onSaveError);
        };
    })
